/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined' || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.KitchenEstimator = (await import('./pages/KitchenEstimator')).KitchenEstimator;
    Components.Home = (await import('./pages/Home')).Home;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages = {}) => ({
  kitchenEstimator: {
    name: 'KitchenEstimator',
    componentName: 'KitchenEstimator',
    chunk: () => import('./pages/KitchenEstimator'),
    get component() {
      return ssr
        ? serverPages.KitchenEstimator
        : currentRouteName === 'KitchenEstimator'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.KitchenEstimator,
          }))
          );
    },
    path: '/:context?/kitchen-estimator/:slug?/:omsId',
    channel: null,
  },
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import('./pages/Home'),
    get component() {
      return ssr
        ? serverPages.Home
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/',
    channel: null,
  },
});
